import { classNames } from "../../utils"
import { Flex, type FlexProps } from "../Flex/Flex"

export type FlexStartProps = FlexProps

export function FlexStart({ className, ...rest }: FlexStartProps) {
  return <Flex className={classNames("justify-start", className)} {...rest} />
}
